/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".errorDialog[_ngcontent-%COMP%]{background:#fff;border-radius:0;width:44.25rem}.buttonText[_ngcontent-%COMP%]{color:#fff;font-size:.875rem;font-weight:400;letter-spacing:.01rem;line-height:1.063rem}.okButton[_ngcontent-%COMP%]{background:#00789e;border-radius:.125rem;height:2.75rem;width:11.25rem;display:inline-block;cursor:pointer;margin-top:1rem;border-width:0}.okButton[_ngcontent-%COMP%]:hover{background:#005984;border-radius:.125rem;box-shadow:0 .125rem .25rem 0 rgba(76,76,76,.4)}"];
export { styles as styles };
